<template>
  <div class="container" id="profile">
    <div class="row pt-4">
      <div class="col pl-5">
        <div class="row">
          <div class="col">
            <div class="float-right">
              <router-link id="previousLink" :to="previousPath">
                <button class="btn bg-grey btn-primary">Back</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Profile />

  </div>
</template>

<script>
import Profile from './Profile'
export default {
  components:{
    Profile,
  },
  data(){
    return{
      previousPath: "/"
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousPath = from
    })
  }
}
</script>

<style>

</style>
